export default __webpack_public_path__ + "static/media/IMG_20210706_175538.531daa6c.jpg";